import { Avatar, Drawer, Skeleton } from "antd";
import { calculateTimeDifference } from "common/enums";
import AppResult from "components/appResults";
import Matiers from "components/matiers";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetHistoriqueReservationsTeacherQuery } from "store/services/teacher/classes.services";
import ArrowBack from "../../../../assets/images/app/arrow_back.svg";
import ClockIcon from "../../../../assets/images/app/clock_icon.svg";
import students from "../../../../assets/images/app/iam_student.svg";
import s from "../assets/calendar.module.css";

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

interface CoursesRoomProps {
  course?: object | any;
}

const CoursesRoom: FC<CoursesRoomProps> = ({ course }) => {

  const auth = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  return (
    <div className={s.historyClasseCard} style={{ cursor: "pointer" }}>
      <div className={s.historyCardClassBox}>
        <div className={s.avatarNameBox}>
          <Avatar.Group
            maxCount={3}
            maxStyle={{
              color: "#f56a00",
              backgroundColor: "#fde3cf",
            }}
            style={{ marginRight: isMobile ? "0px" : "5px" }}
          >
            <Avatar
              size={45}
              style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile && course?.typeCreneaux !== "individuel" ? "25px" : "0px" }}
              src={course?.typeCreneaux === "collectif" ? students : course?.studId?.profile}
            />
            {course?.typeCreneaux !== "individuel" && <Avatar
              size={45}
              style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile ? "0px" : "-25px" }}
              src={course?.typeCreneaux === "collectif" ? students : course?.studId?.profile}
            />}
            {course?.typeCreneaux !== "individuel" && <Avatar
              size={45}
              style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile ? "-25px" : "-50px" }}
              src={course?.typeCreneaux === "collectif" ? students : course?.studId?.profile}
            />}
          </Avatar.Group>
          <div style={{ position: "relative", top: isMobile ? "5px" : "0px", left: isMobile ? "0px" : !isMobile && course?.typeCreneaux !== "individuel" ? "-40px" : "15px", fontSize: isMobile ? "1em" : "13px", textTransform: "capitalize" }}>{course?.typeCreneaux !== "individuel" ? "Cours collectif" : course?.studId?.firstname + " " + course?.studId?.lastname}</div>
        </div>
        {isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <Matiers
          cours={course?.topic?.title || "null"}
          level={course?.level?.title || "null"}
        />}
        <div className={course?.typeCreneaux !== "collectif" ? s.historyDetailsBox : s.historyDetailsBoxCollective}>
          <div className={s.timeBox}>
            {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: isMobile ? "0px" : "10px" }}></img>}
            <div className={s.times}>
              <span className={s.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: isMobile ? "5px" : "10px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
              <span className={s.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
            </div>
          </div>
          {!isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <div style={{ width: "32%" }}>
            <Matiers
              cours={course?.topic?.title || "null"}
              level={course?.level?.title || "null"}
            />
          </div>}
        </div>
        {course?.typeCreneaux === "collectif" ? <div className={s.historyPriceBox}>{course?.pricePerStudent ? course?.pricePerStudent + " Crédit" : course?.price + " Crédit"}</div> :
          course?.codeCoupon && (course?.codeCoupon?.couponType === "FREE_CLASS" || course?.codeCoupon?.couponType === "FREE_LINK_DISCOUNT") ? <div className={s.historyPriceBox}>Cours gratuit</div> : <div className={s.historyPriceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div>}
      </div>
    </div>
  );
};

const DrawerHistorique: FC<Props> = ({ open, setOpen }) => {

  const { user } = useSelector((state) => state.auth);
  const {
    data: historiques,
    isLoading,
    isSuccess,
    refetch
  } = useGetHistoriqueReservationsTeacherQuery(user?._id);
  const [courses, setCourses] = useState<any>([]);

  useEffect(() => {
    refetch();
  }, [user]);

  useEffect(() => {
    if (historiques?.data) {
      const sortedCourses = [...historiques.data].sort(
        (a: any, b: any) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [historiques]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  return (
    <Drawer
      className="drawer"
      visible={open}
      onClose={() => setOpen((open: boolean) => !open)}
      title={<div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent" }}>Mon historique</div>}
      width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "85%" : isMediumScreen ? "80%" : isNormalScreen ? "70%" : "65%"}
      headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
      closeIcon={
        <img
          src={ArrowBack}
          height={isMobile ? 10 : 18}
          style={{}}
        ></img>
      }
      drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "30px", borderBottomLeftRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
    >
      {isLoading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (<div className={s.historyCalendar}>
        {historiques?.data?.length > 0 ? (
          courses && Object.keys(courses)?.map((date) => {
            return (
              <>
                <div key={date} style={{ marginTop: "10px" }}>
                  <div className={s.dateBox}>
                    {new Intl.DateTimeFormat("fr-FR", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    }).format(new Date(date))}
                    <div className={s.horizontalLine}></div>
                  </div>
                  {!isMobile && courses[date].map((course: any) => (
                    <div key={course.id}>
                      <CoursesRoom course={course} />
                    </div>
                  ))}

                  {isMobile && <div className={s.cardDisplay}>
                    {courses[date].map((course: any) => (
                      <div key={course.id}>
                        <CoursesRoom course={course} />
                      </div>
                    ))}
                  </div>}
                </div>
              </>
            );
          })
        ) : (
          <div className={s.emptyClass}>
            <AppResult status={"info"} title={"Aucune séance"}></AppResult>
          </div>
        )}
      </div>
      )}
    </Drawer>
  );
};

export default DrawerHistorique;
